import React from 'react'
import './genres.css'
const Genres = () => {
  return (
    <div>Genres</div>
  )
}

export {Genres};
